import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import axios from "axios";
import fileDownload from 'js-file-download';
import classnames from 'classnames';
import { WithStyles, withStyles } from '@mui/styles';

import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import { withTranslate } from '../../core/TenantProvider';
import { ReducerState } from "../../redux/modules";
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import APImage from '../../components/atoms/APImage';
import APEmbed from '../../components/atoms/APEmbed';
import ResourcesItemContainerStyles from './styles/ResourcesItemContainer.style';

import { ReactComponent as SVGCopyIcon } from './assets/icons/icon-copy.svg';
import { ReactComponent as SVGDownloadIcon } from './assets/icons/icon-download.svg';
import { ReactComponent as SVGTickIcon } from './assets/icons/icon-tick-circle.svg';
import { ReactComponent as SVGCloseIcon } from './assets/icons/icon-close.svg';
import fallbackImage from "../../components/atoms/APImage/assets/images/widget-preview-thumb.jpg";
import { actions as servicesDowntimeAction } from '../../redux/modules/servicesDowntime';

interface ResourcesItemContainerProps extends WithStyles<typeof ResourcesItemContainerStyles> {
    translate: Function,
    componentData: any,
    affiliateDetails: any,
    getServicesErrorObj: Function
}

interface ResourcesItemContainerState {
    copySuccess: boolean,
    validFileUrl: boolean,
    isDownloading: boolean
    downloadError: boolean
}

export type ResourcesItem = {
    url_to_actual_image: string,
    image_title: string | null,
    image_dimensions: string,
    orgUrl: string,
    asset_id: string,
    file_type: string,
    category: string
}

class ResourcesItemContainer extends Component<ResourcesItemContainerProps, ResourcesItemContainerState> {

    constructor(props: any) {
        super(props);
        this.state = {
            copySuccess: false,
            validFileUrl: true,
            isDownloading: false,
            downloadError: false
        };

        this.downloadFile = this.downloadFile.bind(this);
    }

    // code copy
    renderCopyHTML() {

        const { componentData, affiliateDetails } = this.props;

        const affNumber = affiliateDetails.affiliate.affiliate_Number;
        const orgUrl = (componentData.orgUrl) ? componentData.orgUrl : '';
        const assetType = (componentData.assetType) ? componentData.assetType : 'img';
        const assetID = (componentData.asset_id) ? componentData.asset_id : '';
        const assetUrl = (componentData.url_to_actual_image) ? componentData.url_to_actual_image : '';

        // Logos / banners / Widgets / Factsheets / Email templates / Leaflets & brochures
        let renderedHTML = '';
        switch (assetType) {

            case 'pdf':
                renderedHTML = `<embed src="${assetUrl}" width="50%" height="50%" />`;
                break;

            case 'email':
                renderedHTML = '';
                break;

            case 'widget':
                renderedHTML = '';
                break;

            default:
                renderedHTML = `<a href="${orgUrl}/en/es?afflno=${affNumber}&assetid=${assetID}"><img src="${assetUrl}"/></a>`;
        }

        return renderedHTML;
    }

    handleClose = (e?: React.SyntheticEvent<any, Event> | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ copySuccess: false });
    };

    downloadFile() {
        const { componentData, getServicesErrorObj } = this.props;

        let downloadURL = `/Affiliate${getFileUrl(componentData.url_to_actual_image).replace("servlet.ImageServer?id=", "servlet.FileDownload?file=")}`;
        const fileName = formatFilename(componentData.image_title);

        this.setState({
            isDownloading: true,
            downloadError: false
        }, () => {

            axios.get(downloadURL, {
                responseType: 'blob',
            }).then(res => {
                let ext = '';
                const apiFileType = componentData.file_type.toLowerCase();
                if (res.status === 200 && apiFileType) {

                    switch (res.data.type) {
                        case 'image/jpeg':
                            ext = 'jpg'
                            break;
                        case 'image/png':
                            ext = 'png'
                            break;
                        case 'image/gif':
                            ext = 'gif'
                            break;
                        case 'application/pdf':
                            ext = 'pdf'
                            break;
                    }

                    if (apiFileType === 'gif') {
                        ext = 'gif'
                    }

                    fileDownload(res.data, `${fileName}.${ext}`);
                    this.setState({
                        isDownloading: false,
                        downloadError: false
                    });

                } else {
                    this.setState({
                        isDownloading: false,
                        downloadError: true
                    });
                }

            }).catch(error => {
                console.log(error);
                this.setState({
                    isDownloading: false,
                    downloadError: true
                });
                getServicesErrorObj(error);
            });
        })
    }

    render() {
        const {
            classes,
            translate,
            componentData,
            affiliateDetails
        } = this.props;

        const { copySuccess, isDownloading, downloadError } = this.state;

        const resourcesItemContainer = classnames(classes.resourcesItemContainer, {
            [classes.resourcesItemContainerPDF]: componentData.file_type === 'pdf'
        });
        const resourcesItem = classnames(classes.resourcesItem, {
            [classes.resourcesItemPDf]: componentData.file_type === 'pdf'
        });
        const resourcesActions = classnames(classes.resourcesActions, {
            [classes.resourcesActionsPdf]: componentData.file_type === 'pdf'
        });
        return (
            <div className={resourcesItemContainer}>

                {copySuccess ?
                    <Snackbar className={classes.APSnackBar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={copySuccess} autoHideDuration={3000} onClose={this.handleClose}>
                        <div><SVGTickIcon className={classes.svgTick} /> {translate('trackingCode.copycode.success')} <SVGCloseIcon className={classes.svgIconClose} onClick={this.handleClose} /></div>
                    </Snackbar> : null}

                <h2>{translate('resourcesItem.details.heading')}</h2>

                {/* Items start here */}
                <div className={resourcesItem}>

                    {componentData.file_type === 'pdf' && (
                        <div className={classes.pdfHeader} >
                            <div>
                                <h3 className={classes.resourcesCopyTitle}>{componentData.image_title}</h3>
                                <p className={classes.resourcesCopySubTitle} >{componentData.category}</p>
                            </div>
                            <div className={resourcesActions}>
                                <button disabled={isDownloading} onClick={this.downloadFile} className={'resourcesPdfBtn'}>
                                    {isDownloading && <CircularProgress className={classes.pdfLoadingIcon} size={18} />}
                                    <SVGDownloadIcon /> {translate('resources.details.svg.download')}
                                </button>
                                {downloadError &&
                                    <p className={classes.resourcesDownloadError}>There was an error downloading this file. Please try again later.</p>}
                            </div>
                        </div>
                    )}

                    <div className={(componentData.file_type === 'pdf') ? classes.resourcesPdf : (classes.resourcesImg) ? classes.resourcesImg : 'jpg'}>
                        {getResourceTypePreview(componentData, affiliateDetails, this.props)}
                    </div>

                    {componentData.category !== 'Widget' && componentData.file_type !== 'pdf' &&

                        <div className={classes.resourcesCopy}>

                            <h3 className={classes.resourcesCopyTitle}>{componentData.image_title}</h3>
                            <p className={classes.resourcesCopySubTitle}>{componentData.category}</p>

                            <div className={classes.resourcesCopyHtml}>
                                {getResourceTypeCode(componentData, affiliateDetails)}
                            </div>

                            <div className={classes.resourcesActions}>
                                <CopyToClipboard text={getResourceTypeCode(componentData, affiliateDetails)} onCopy={() => this.setState({ copySuccess: true })}>
                                    <button><SVGCopyIcon /> {translate('resourcesItem.details.copyLink')}</button>
                                </CopyToClipboard> <span>|</span> <button disabled={isDownloading} onClick={this.downloadFile} className={classes.resourcesBtn}><SVGDownloadIcon /> {translate('resources.details.svg.download')}</button>
                                {isDownloading && <CircularProgress className={classes.loadingIcon} size={18} />}
                            </div>

                            {downloadError &&
                                <p className={classes.resourcesDownloadError}>There was an error downloading this file. Please try again later.</p>}

                        </div>
                    }

                </div>

            </div>
        );
    }
}

const getFileUrl = (url) => url.replace(/^((http[s]):\/)?\/?([^:\/\s]+)/, '');/* eslint-disable-line */
const formatFilename = (filename) => filename.toLowerCase().replace(/\s+/g, '');
type WidgetIframeProps = {
    iframeUrl: string;
};

const WidgetIframe: React.FC<WidgetIframeProps> = ({ iframeUrl }) => {
    if (!iframeUrl) {
        return null;
    }

    return (
        <iframe
            src={iframeUrl}
            title="Resource widget"
            width="100%"
            height="660"
            tabIndex={0}
            scrolling="no"
            frameBorder={0}
            loading="lazy"
            aria-label="Resource widget preview"
        />
    );
};

const getResourceTypePreview = (resource: ResourcesItem, affiliateDetails: any, props: any) => {

    if (resource.category === 'Widget') {
        let iframeUrl = '';
        switch (props.componentData.orgCode) {
            case 'CD':
                iframeUrl = `https://www.currenciesdirect.com/ui/widgets/fxconverter2/?afflno=${affiliateDetails.affiliate.affiliate_Number}&assetid=${resource.asset_id}`;
                break;
            case 'CDSA':
                iframeUrl = `https://www.currenciesdirect.com/ui/widgets/fxconverter2/?afflno=${affiliateDetails.affiliate.affiliate_Number}&assetid=${resource.asset_id}`;
                break;
            case 'TorFX':
                iframeUrl = `https://widgets.torfx.com/scripts/currencyconverter/configure.html?afflno=${affiliateDetails.affiliate.affiliate_Number}&assetid=${resource.asset_id}`;
                break;
            case 'TorFXOz':
                iframeUrl = `https://widgets.torfx.com.au/scripts/currencyconverter/configure.html?afflno=${affiliateDetails.affiliate.affiliate_Number}&assetid=${resource.asset_id}`;
                break;
            case 'FCG':
                iframeUrl = `https://www.currenciesdirect.com/ui/widgets/fxconverter2/?afflno=${affiliateDetails.affiliate.affiliate_Number}&assetid=${resource.asset_id}`;
                break;
        }
        return (
            <div>
                <WidgetIframe iframeUrl={iframeUrl} />
            </div>
        );
    }

    const fileUrl = `/Affiliate${getFileUrl(`${resource.url_to_actual_image}`)}`;
    switch (resource.file_type) {
        case 'gif':
        case 'GIF':
        case 'jpg':
        case 'png':
        case 'jpeg':
            return (<APImage imageSrc={fileUrl} imageClass={``} />);

        case 'pdf':
            return (<div><APEmbed title="Title of asset" embedSrc={fileUrl} embedClass={``} /></div>);

        //case 'pdf':
        default:
            return (<img className={``} alt={''} src={fallbackImage} />);
    }
};

const getResourceTypeCode = (resource: ResourcesItem, affiliateDetails: any) => {

    const assetType = (resource.file_type) ? resource.file_type : 'img';

    const affNumber = affiliateDetails.affiliate.affiliate_Number;
    const orgUrl = (resource.orgUrl) ? resource.orgUrl : '';
    const assetID = (resource.asset_id) ? resource.asset_id : '';
    const assetUrl = (resource.url_to_actual_image) ? resource.url_to_actual_image : '';

    let renderedHTML = '';
    switch (assetType) {

        case 'pdf':
        case 'html':
        case 'email':
            renderedHTML = ``;
            break;

        default:
            renderedHTML = `<a href="${orgUrl}/en/es?afflno=${affNumber}&assetid=${assetID}"><img src="${assetUrl}"/></a>`;
    }

    return renderedHTML;
};

const mapStateToProps = (store: ReducerState) => ({
    affiliateDetails: store.user.affiliateDetails,
    componentData: store.uiStates.componentData
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    getServicesErrorObj: servicesDowntimeAction.getServicesErrorObj
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
    withTranslate(withStyles(ResourcesItemContainerStyles)(
        (ResourcesItemContainer))
    )
);